<template>
    <b-container class="Footer wrapper" :class="displayFooter">
        <b-row cols="12">
            <b-col class="footerSmallFlex">
                <div class="footerSmallFirst">
                    <img src="../assets/logoFooter.png" alt="it Jonction">
                    <p class="footerP">{{$t('footer')}}</p>
                </div>
                <div class="footerLinksSmall">
                    <div @click="footerRedirect('/')" class="footerLink">Home</div>
                    <div @click="footerRedirect('/process')" class="footerLink">{{$t('link1')}}</div>
                    <div @click="footerRedirect('/tech')" class="footerLink">{{$t('link2')}}</div>
                    <DiscussBtn />
                </div>
            </b-col>
        </b-row>

        <b-row cols="12">
            <b-col class="footerFootSmall">
                 <ParisLove />
                <!-- <img src="../assets/cookedInParis.png" alt="From Paris with Love"> -->
                <p class="footerRights">© 2019 IT Jonction Lab | All Rights Reserved</p>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import DiscussBtn from "./DiscussBtn.vue"
import ParisLove from "./ParisLove.vue"

export default {
    name:'Footer',
    components: {
        DiscussBtn,
        ParisLove
    },
    computed: {
        displayFooter: function () {
            if(window.innerWidth>768) {
                return 'dn'
            } else {
                return 'footer-bloc'
            }
        }
    },
    methods: {
        footerRedirect: function(pathTo) {
            this.$router.push({ path: pathTo })
            window.scrollTo(0,0)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/style/footerSmall.scss';
</style>